<template>
  <div class="address-dialog">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisiable"
      size="70%"
      @close="handleClose"
    >
      <el-form
        label-width="130px"
        :model="dataForm"
        ref="dataForm"
        :rules="rules"
      >
        <el-row>
          <el-col :span="22">
            <el-form-item label="地址信息:" prop="provinces">
              <el-cascader
                ref="addressCascader"
                v-model="dataForm.provinces"
                placeholder="选择所在地区"
                :options="cityJSON"
                :props="{ expandTrigger: 'hover' }"
                style="width: 100%"
                clearable
                @change="provincesChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="详细地址:" prop="address">
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 5 }"
                placeholder="输入详细地址"
                v-model="dataForm.address"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="收货人姓名:" prop="name">
              <el-input
                placeholder="输入收货人姓名"
                v-model="dataForm.name"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="手机号码:" prop="phone">
              <el-input
                placeholder="输入手机号码"
                v-model="dataForm.phone"
                clearable
                :maxlength="11"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="设为默认:">
              <el-switch v-model="dataForm.is_default"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toSaveAddress">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addAddressInfo, editAddressInfo } from "@/api/home";
import { regionData, TextToCode } from 'element-china-area-data'
export default {
  props: {
    dialogTitle: {
      type: String,
      default: "",
    },
    addressInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialogVisiable: true,
      dataForm: {
        provinces: "",
        adcode:'',
        province:'',
        city:'',
        district:'',
        address: "",
        name: "",
        phone: "",
        is_default: false,
      },
      cityJSON:regionData,
      rules: {
        provinces: [
          { required: true, message: "请选择所在地区", trigger: "change" },
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: ["change", "blur"],
          },
        ],
        name: [
          {
            required: true,
            message: "请输入收货人姓名",
            trigger: ["change", "blur"],
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["change", "blur"],
          },
        ],
      },
      btnLoading: false,
    };
  },
  created() {
    if(this.addressInfo) {
        this.getAddressInfo()
    }
  },
  methods: {
    getAddressInfo() {
        for (const prop in this.dataForm) {
            this.dataForm[prop] = this.addressInfo[prop]
        }
        this.dataForm.is_default = this.addressInfo.is_default == 1 ? true : false
        const provinceCode = TextToCode[this.addressInfo.province].code
        const cityCode = TextToCode[this.addressInfo.province][this.addressInfo.city].code
        const districtCode = TextToCode[this.addressInfo.province][this.addressInfo.city][this.addressInfo.district].code
        this.$set(this.dataForm,'provinces',[provinceCode,cityCode,districtCode])
    },
    // 保存地址
    toSaveAddress() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          if (this.addressInfo) {
            // edit
            editAddressInfo({
              ...this.dataForm,
              is_default: this.dataForm.is_default ? 1 : 0,
              id:this.addressInfo.id,
              is_delete:0
            }).then((res) => {
                this.btnLoading = false
              if (res.code === 10000) {
                this.$message.success("修改成功");
                this.handleClose(true);
              }
            }).catch(_=>{
                this.btnLoading = false
            })
          } else {
            // add
            this.btnLoading = true
            addAddressInfo({
              ...this.dataForm,
              is_default: this.dataForm.is_default ? 1 : 0,
            }).then((res) => {
                this.btnLoading = false
              if (res.code === 10000) {
                this.$message.success("添加成功");
                this.handleClose(true);
              }
            }).catch(_=>{
                this.btnLoading = false
            })
          }
        }
      });
    },
    provincesChange(value) {
      if (value && value.length) {
        this.dataForm.adcode = value[2];
        let labelArr =
        this.$refs["addressCascader"].getCheckedNodes()[0].pathLabels;
        this.dataForm.province = labelArr[0];
        this.dataForm.city = labelArr[1];
        this.dataForm.district = labelArr[2];
      }
    },
    handleClose(isClickSave) {
      this.$refs.dataForm.resetFields();
      this.btnLoading = false;
      this.dialogVisiable = false;
      this.$emit('closeDialog',isClickSave)
    },
  },
};
</script>

<style scoped>
.address-dialog /deep/.el-dialog__footer {
  text-align: center;
}
</style>